import type { GenericSwitcherProps } from '../../ui/components/generic-switcher';
import { loadAtlassianSwitcher, loadGenericSwitcher } from '../../ui/components/loaders';

export default (): Promise<(props: GenericSwitcherProps) => React.JSX.Element> => {
	loadAtlassianSwitcher();

	return loadGenericSwitcher();
};
